import { createContext } from 'react'

export const VariableLabelsContext = createContext<Map<string, string>>(new Map())
